export default __webpack_public_path__ + "static/media/man.e3ba619a.jpg";